import {Component, computed, inject, Signal} from '@angular/core';
import {RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {IconComponent} from '../../shared/icon/icon.component';
import {UserMenuComponent} from '../user-menu/user-menu.component';
import {OrganizationService} from '../../../services/organization.service';
import {IconType} from "../../icons";

interface TabDef {
  label: string,
  path: string | Signal<string>,
  icon: IconType,
  condition?: Signal<boolean>
}

@Component({
  selector: 'app-user-page',
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    IconComponent,
    UserMenuComponent
  ],
  templateUrl: './user-page.component.html',
  styleUrl: './user-page.component.scss',
  host: {
    class: 'app-fill-screen app-column-fill hh-fill'
  }
})
export class UserPageComponent {
  protected readonly orgService = inject(OrganizationService)

  protected readonly showSettings = computed(() => {
    const org = this.orgService.activeOrganization()
    return (org && !org.isPersonal && org.isAdmin) || false
  })

  protected readonly settingsPath = computed(() => {
    const org = this.orgService.activeOrganization()
    return `/organizations/${org?.id}`
  })

  protected readonly tabs: readonly TabDef[] = [
    { label: 'Home', path: '/home', icon: 'home' },
    { label: 'Marketplace', path: '/marketplace', icon: 'marketplace' },
    { label: 'Prompts', path: '/prompts', icon: 'prompt' },
    { label: 'Packs', path: '/packs', icon: 'pack' },
    { label: '', path: '', icon: 'private'},
    { label: 'Settings', path: this.settingsPath, icon: 'settings', condition: this.showSettings },
    { label: 'Profile', path: '/profile', icon: 'user' }
  ]

  protected tabPath(tab: TabDef): string {
    return typeof tab.path === 'string' ? tab.path : tab.path()
  }
}
